import { fetchExhibitions } from '~/api/exhibitions';
import { exhibitionsAsList } from '~/api/exhibitionsAsList';
import ExhibitionList from '~/components/exhibitions/exhibition-list';
import QRCodeDialog from '~/components/qrcode/qrcode-dialog';
import { useQRCodeHandler } from '~/components/qrcode/useQRCodeHandler';
import { plurals } from '~/lib/i18n/plurals';
import type { Route } from './+types/home';
import Footer from './footer';

export function meta() {
  return [{ title: 'musea' }, { name: 'description', content: 'musea!' }];
}

export function HydrateFallback() {
  return <div>Loading...</div>;
}

export async function loader() {
  const exhibitions = exhibitionsAsList(await fetchExhibitions());
  const open = exhibitions.filter(exhibition => !exhibition.closed);
  const highlighted = open.filter(exhibition => exhibition.highlighted);
  const closed = exhibitions.filter(exhibition => exhibition.closed);
  return {
    open,
    highlighted,
    closed,
  };
}

export default function Home({ loaderData }: Route.ComponentProps) {
  const { open, highlighted, closed } = loaderData;
  const lang = 'pt';

  // handlers
  const { handleQRCodeScanned, qrCodeScannerOpen, setQrCodeScannerOpen } = useQRCodeHandler();
  // UI
  return (
    <div className="">
      {/* scanner dialog */}
      <QRCodeDialog
        open={qrCodeScannerOpen}
        onOpenChange={value => setQrCodeScannerOpen(value)}
        onQRCodeScanned={handleQRCodeScanned}
      />
      {/* test only */}
      {/* <Footer qrcodeScannerHandler={() => setQrCodeScannerOpen(true)} /> */}
      {/* exposições */}
      <div>
        {highlighted.length ? (
          <ExhibitionList
            lang={lang}
            size="lg"
            exhibitions={highlighted}
            title={`${highlighted.length} ${plurals('exposição', highlighted.length)} em destaque`}
          />
        ) : null}
        {open.length ? (
          <ExhibitionList
            lang={lang}
            exhibitions={open}
            size="sm"
            title={`${open.length} ${plurals('exposição', open.length)} acontecendo agora`}
          />
        ) : null}
        {closed.length ? (
          <ExhibitionList
            lang={lang}
            exhibitions={closed}
            size="sm"
            title={`${closed.length} ${plurals('exposição', closed.length)} ${plurals(
              'encerrada',
              closed.length
            )}`}
          />
        ) : null}
      </div>
      <Footer qrcodeScannerHandler={() => setQrCodeScannerOpen(true)} />
    </div>
  );
}
